import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../context/auth";
import { Link } from "react-router-dom";
import moment from "moment";
import { Loader, Dimmer } from "semantic-ui-react";
import axios from "axios";
import { CambiarClave } from "./configuracionGeneral/modalCambiarClave";
import { Mensaje } from "./mensajes";
import { formatMoneda } from "../util/varios";
import { useBcv } from "../hooks/useBcv";

function Header(props) {
  moment.locale("es");
  const token = sessionStorage.getItem("jwtToken");
  const op = require("../../public/modulos/datos");

  const { user } = useContext(AuthContext);
  const fechaSistema = JSON.parse(sessionStorage.getItem("fechasistema"));
  const usuario = JSON.parse(sessionStorage.getItem("login"));

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mostrar, setMostrar] = useState(false);
  const [activate, setActivate] = useState(false);
  const { moneda } = useBcv();

  let el;
  function menuclick() {
    props.onCambiar("inicio");
    if ((el = document.getElementById("wrapper"))) {
      el.classList.toggle("toggled");
    }
  }

  const seleccionarRegistros = () => {
    let campos =
      "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
    let nomtab =
      "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
    let orden = "m.idmoneda";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    //setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].subpredeterminada) {
         //       setMoneda(response.data[i]);
              }
            }
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        //  setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  useEffect(() => {
    seleccionarRegistros();
  }, []);

  const header = user && (
    <nav
      className="h-10 m-0 col-md-12 navbar navbar-expand-lg navbar-light azulGradiant py-2 px-2 d-flex justify-content-between"
      id="one"
    >
      {props.path === "inicio" ? (
        <div>
          <div className="mx-2 d-none d-xl-block">
            <i
              className="fas fa-align-left  text-light fs-4"
              onClick={menuclick}
              id="menu-toggle"
            />
          </div>

          <div className="col-1  d-block d-xl-none">
            <i
              className="fas fa-align-left  text-light fs-4"
              onClick={menuclick}
              id="menu-toggle"
            />
          </div>
        </div>
      ) : (
        <div>
          <div className="mx-2 d-none d-xl-block">
            <Link to="/inicio">
              <button
                onClick={menuclick}
                className="btn btn-xs btn-danger p-2 rounded-pill"
                style={{ fontWeight: "bold" }}
              >
                <i className="far fa-arrow-alt-circle-left"> Volver</i>
              </button>
            </Link>
          </div>

          <div className="col-1 d-block d-xl-none">
            <Link to="/inicio">
              <button
                onClick={menuclick}
                className="btn btn-xs btn-danger p-2 rounded-pill"
                style={{ fontWeight: "bold" }}
              >
                <i className="far fa-arrow-alt-circle-left"> Volver</i>
              </button>
            </Link>
          </div>
        </div>
      )}

      <div className="col d-none d-xl-block m-0 px-0">
        <label className="titulo-header">{props.titulo}</label>
      </div>

      <div className="col-4 d-flex justify-content-end ">
        <label className="text-warning fw-bold d-none d-xl-block mx-3">
          {moneda.simbolo +
            " " +
            formatMoneda(
              moneda.valormoneda.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            )}
        </label>
        <label className="text-light fw-bold d-none d-xl-block">
          <i className="fas fa-calendar-alt me-2" />
          {moment(fechaSistema).format("L")}
        </label>
        <div className="dropdown ">
          <a
            className=" dropdown-toggle text-light fw-bold mx-4"
            type="button"
            id="dropdownMenuButton"
            data-mdb-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fas fa-user me-2" />
            {usuario}
          </a>
          <ul
            className="dropdown-menu sombras "
            aria-labelledby="dropdownMenuButton"
          >
            <li
              onClick={() => {
                setMostrar(true);
              }}
            >
              <Link to="#" className="dropdown-item ripple bg-light">
                <span>
                  <i className="fas fa-key fa-fw me-1" />
                  Cambiar Clave
                </span>
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <CambiarClave
        usuario={usuario ? usuario : ""}
        show={mostrar}
        onHide={() => {
          setMostrar(false);
        }}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>
    </nav>
  );

  return header;
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.js